const state = {
  pageResult: {

  },
  receivePageResult: {

  },
  receiveForm: {

  },
  resultForm: {

  },
  pageResultRequest: {

  },
  resultFormRequest: {

  },
  formDetailMaterial: {

  },
  formOtherMaterial:{},
  handleType: 'view',
  rootNode: {},
  createComponentQuery: {},
  toolMdsIdList:[],
  updateMdsList:[],
  // backParams:{

  // }
}
const mutations = {
  SET_PAGERESULT: (state, pageResult) => {
    state.pageResult = pageResult
  },
  SET_CREATECOMPONENTQUERY: (state, createComponentQuery) => {
    state.createComponentQuery = createComponentQuery
  },
  SET_RECEIVEPAGERESULT: (state, pageResult) => {
    state.receivePageResult = pageResult
  },
  SET_RECEIVEFORM: (state, receiveForm) => {
    state.receiveForm = receiveForm
  },
  SET_RESULTFORM: (state, resultForm) => {
    state.resultForm = resultForm
  },
  SET_PAGERESULTREQUEST: (state, pageResult) => {
    state.pageResultRequest = pageResult
  },
  SET_RESULTFORMREQUEST: (state, resultForm) => {
    state.resultFormRequest = resultForm
  },
  SET_CHANDLETYPE: (state, handleType) => {
    state.handleType = handleType
  },
  SET_FORM_DETAIL_MATERIAL: (state, formDetailMaterial) => {
    state.formDetailMaterial = formDetailMaterial
  },
  SET_OTHER_MATERIAL: (state, formOtherMaterial) => {
    state.formOtherMaterial = formOtherMaterial
  },
  SET_ROOTNODE: (state, rootNode) => {
    state.rootNode = rootNode
  },
  SET_TOOLMDSIDLIST: (state, toolMdsIdList) => {
    state.toolMdsIdList = toolMdsIdList
  },
  SET_UPDATEMDSLIST:(state,updateMdsList)=>{
    state.updateMdsList = updateMdsList
  }
  // SET_BACKPARAMS: (state, backParams) => {
  //   state.backParams = backParams
  // },
}

const actions = {
  addErrorLog({
    commit
  }, log) {
    commit('ADD_ERROR_LOG', log)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
